import { axiosObject } from "../config";

function getTeamMembers(team_uuid: any) {
    return new Promise((resolve, reject) => {
        let uri = `access/loco/resource/team-members/_read`;
        let payload = {
            apiConfig: {
                includeRelations: ["attributes", "user"],
            },
            limitBy: { per_page: 999, page: 1 },
            filterBy: [
                {
                    attribute: "team_uuid",
                    op: "eq",
                    value: team_uuid,
                },
            ],
        };

        axiosObject
            .post(uri, payload)
            .then((response) => {
                resolve(response.data);
            })
            .catch((errors) => {
                reject(errors);
            });
    });
}

function getTeamMembersWithPagination(limitBy: any, team_uuid: any) {
    return new Promise((resolve, reject) => {
        let uri = `access/loco/resource/team-members/_read`;
        let payload = {
            apiConfig: {
                includeRelations: ["attributes", "user"],
            },
            limitBy: limitBy,
            filterBy: [
                {
                    attribute: "team_uuid",
                    op: "eq",
                    value: team_uuid,
                },
            ],
        };

        axiosObject
            .post(uri, payload)
            .then((response) => {
                resolve(response.data);
            })
            .catch((errors) => {
                reject(errors);
            });
    });
}

export { getTeamMembers, getTeamMembersWithPagination };
